import Home from "./pages/Home";
import LeaveBehind from "./pages/LeaveBehind";
import { LazyMotion } from "framer-motion";
import { Routes, Route } from "react-router-dom";

import "./_fonts.css";
import "./_styles.css";

const AppWrapper = () => {
  const features = () => import("./utils/animation-features").then((res) => res.default);
  return (
    <LazyMotion features={features}>
      <Home />
    </LazyMotion>
  );
};

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<AppWrapper />} />
      <Route path="/:degree" element={<AppWrapper />} />
      <Route path="/:degree/:category" element={<AppWrapper />} />
      <Route path="/more-results" element={<LeaveBehind />} />
    </Routes>
  );
}
